import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './Logo.svg'


_pushScopeId("data-v-909d1286")
const _hoisted_1 = { class: "app-logo flex min-w-[185px] items-center sm:mr-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "35",
  height: "35",
  class: "mr-2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" POLARIS ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" D E X ")
_popScopeId()

import { computed } from 'vue';

import useDarkMode from '@/composables/useDarkMode';
import useTailwind from '@/composables/useTailwind';

/**
 * TYPES
 */
type Props = {
  forceDark?: boolean;
};

/**
 * PROPS & EMITS
 */

export default _defineComponent({
  props: {
    forceDark: { type: Boolean, required: false, default: false }
  } as unknown as undefined,
  setup(__props: {
  forceDark?: boolean;
}) {

const props = __props


/**
 * COMPOSABLES
 */
const { darkMode } = useDarkMode();
const tailwind = useTailwind();

/**
 * COMPUTED
 */
const fillColor = computed(() => {
  if (props.forceDark) return tailwind.theme.colors.white;

  return darkMode.value
    ? tailwind.theme.colors.white
    : tailwind.theme.colors.gray['900'];
});

return (_ctx: any,_cache: any) => {
  const _component_nobr = _resolveComponent("nobr")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_nobr, { className: "custom-logo-text self-center font-medium" }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createVNode(_component_nobr, { className: "custom-logo-text self-center font-bold" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})